var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('div',{staticClass:"d-flex align-items-end mb-24"},[_c('h4',{staticClass:"mr-8"},[_vm._v("Column Chart")]),_c('p',{staticClass:"hp-badge-text"},[_vm._v("Revenue")])]),_c('div',{staticClass:"overflow-hidden"},[_c('apexchart',{attrs:{"type":"bar","height":"350","legend":"legend","options":_vm.options,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }